/**
 * Helper function to check if an object has a property both at runtime and for Typescript analysis
 */
export default function objectHasProperty<X extends object | null | unknown, Y extends PropertyKey>(
  obj: X,
  prop: Y
): obj is X & Record<Y, unknown> {
  return typeof obj === 'object' && obj != null && prop in obj;
}
